module.exports = __webpack_public_path__ + "media/images/emblems/Maschwanden-blazon-2899c666641f190a1fd6b85f715b0a19.svg";